<template>
  <div  class="order-container">
      <div  :style="{'padding-bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
       <div class="content-block">
         <div class="block-item" style="height: 60px;;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #424242;
line-height: 20px;">
           开票抬头
         </div>
         <div class="full-split-line"></div>
         <div class="block-item" v-for="(payEnterprise,index) in payEnterpriseList" style="border-bottom: .5px solid #efeef3;">
           <!--          <label class="label-checkbox item-content">-->
           <!--            <input type="checkbox" name="accountCheckbox"  :value="payEnterprise" v-model="ListPayEnterprise">-->
           <!--            <div class="item-media group">-->
           <!--              <i class="icon icon-form-checkbox i-style"></i>-->
           <!--            </div>-->
           <!--          </label>-->
           <div :class="getMainClass(payEnterprise)" >
             <div  style="margin-top: 10px;margin-left: 5px" class="open-popup open-enterprise" data-popup=".popup-invoice-title" v-on:click="openSerchPayEnterprise(index,false)">
               {{getPayExperienceLabel(payEnterprise.enterpriseInvoiceTitle)}}
               <span v-if="!payEnterprise.enterpriseInvoiceTitle">
                点击搜索单位
              </span>
               <span :style="getMainStyle(payEnterprise)">
              <span style="padding-right: 5px" v-if="canAddPayEnterprise">
               <img
                 @click="openSerchPayEnterprise(index,true)"
                 class="icon6"
                 style="width: 17px;height: 12px;"
                 referrerpolicy="no-referrer"
                 src="/static/img/修 改.svg"
               />
              </span>
            </span>
             </div>
           </div>
           <div>
             <img
               v-if="canAddPayEnterprise"
               @click="removePayEnterprise(index)"
               class="icon5"
               referrerpolicy="no-referrer"
               src="/static/img/删减.svg"
             />
           </div>
         </div>
         <div class="block-item" v-show="canAddPayEnterprise" @click="addPayEnterprise">
           <div>
             <span class="deep-text-color">增加开票抬头</span>
           </div>
           <div>
             <img
               class="label7"
               referrerpolicy="no-referrer"
               src="/static/img/增加备份.svg"
             />
           </div>
         </div>
       </div>
      </div>
    <div class="footer">
      <div class="footer-content">
        <div class="del-btn" @click="toPayInvoice()"><span class="tag" style="color: #5878fa">取消</span></div>
        <div class="sub-btn"  @click="submitPayEnterprise()"><span class="tag">确定修改</span></div>
      </div>
      <footer-placeholder></footer-placeholder>
    </div>
<!--      <div class="footer">-->
<!--        <div class="footer-content">-->
<!--          <div  class="cancel-btn research-font-color"  @click="toPayInvoice()">取消</div>-->
<!--          <div  class="submit-btn research-background-color"  @click="submitPayEnterprise()">确定修改</div>-->
<!--        </div>-->
<!--        <footer-placeholder></footer-placeholder>-->
<!--      </div>-->
  </div>
</template>


<script>
  // import $ from 'jquery'
  import FooterPlaceholder from '../components/FooterPlaceholder'
  import Emkt from '../../emkt'
  import {mapState, mapMutations} from 'vuex'

  export default {
    created () {
      this.fetchData()
    },
    mounted () {
    },
    watch: {
      'invoiceInfo': function (val) {
        var _this = this
        const samePayEnterprise = _this.payEnterpriseListData.find(mer => val.enterpriseNo === mer.enterpriseNo)
        console.log(samePayEnterprise)
        if (samePayEnterprise) {
          _this.$weui.topTips('该开票抬头已经存在！不可重复添加！')
          return
        }
        _this.payEnterpriseListData.splice(this.payEnterpriseIndex, 1, val)
        console.log(val)
      },
      'ListPayEnterprise': function (val) {
        console.log(val)
      }
    },
    data () {
      return {
        payEnterpriseIndex: null,
        payEnterpriseListData: [],
        showPayEnterprise: true,
        ListPayEnterprise: []
      }
    },
    components: {
      FooterPlaceholder
    },
    computed: {
      ...mapState([
        'sessionInfo', 'invoiceInfo', 'chosenOrder'
      ]),
      payEnterpriseList () {
        return this.payEnterpriseListData
      },
      canAddPayEnterprise () {
        return this.chosenOrder.payType !== 1 && this.showPayEnterprise
      },
      order () {
        if (this.$route.params.order) {
          this.UPDATE_CHOSEN_ORDER(this.$route.params.order)
        }
        return this.chosenOrder
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_CHOSEN_ORDER'
      ]),
      getPayExperienceLabel (label) {
        if (label) {
          return label.length > 15 ? label.substring(0, 15) + '...' : label
        } else {
          return null
        }
      },
      getMainClass (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'main3' : 'main3'
      },
      getMainStyle (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'float: right;' : 'float: right;'
      },
      getTextStyle (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'border: none;' : 'border: none; background-color: rgba(239, 238, 243, 1);'
      },
      addPayEnterprise () {
        let payEnterprise = {}
        this.payEnterpriseListData.push(payEnterprise)
        console.log('this.payEnterpriseList', this.payEnterpriseList)
      },
      removePayEnterprise (index) {
        var _this = this
        if (_this.payEnterpriseListData[index].enterpriseInvoiceTitle) {
          if (_this.payEnterpriseListData.length <= 1) {
            _this.$weui.topTips('订单开票抬头不可为空', 2000)
          } else {
            // _this.$weui.confirm('确定要删除订单开票抬头?', {
            //   title: '提示',
            //   buttons: [{
            //     label: '取消',
            //     type: 'default',
            //     onClick: function () { console.log('no') }
            //   }, {
            //     label: '确定',
            //     type: 'primary',
            //     onClick: function () {
            //       _this.payEnterpriseListData.splice(index, 1)
            //       _this.updatepayEnterprise()
            //       console.log('this.payEnterpriseList', _this.payEnterpriseList)
            //     }
            //   }]
            // })
            _this.payEnterpriseListData.splice(index, 1)
          }
        } else {
          _this.payEnterpriseListData.splice(index, 1)
        }
      },
      openSerchPayEnterprise (index, val) {
        this.payEnterpriseIndex = index
        console.log(index)
      },
      fetchData () {
        var _this = this
        console.log(this.$route.params.order)
        _this.gcapi('getOrderPayEnterpriseNos', _this.order.id).then(function (response) {
          var map = Emkt.getLocalStorage('EmktFirstLevelEnterpriseNoMap')
          let rlist = response.body.result
          if (rlist.length > 0) {
            rlist.forEach(data => {
              let d = map[data]
              if (d !== undefined) {
                let enterprise = {
                  'enterpriseInvoiceTitle': d.enterpriseInvoiceTitle,
                  'enterpriseNo': d.enterpriseNo
                }
                _this.payEnterpriseListData.push(enterprise)
              }
            })
            _this.ListPayEnterprise = _this.payEnterpriseListData
          } else {
            _this.showPayEnterprise = false
          }
        })
      },
      submitPayEnterprise () {
        var _this = this
        _this.$weui.confirm('确定要更新订单开票抬头?', {
          title: '提示',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function () { console.log('no') }
          }, {
            label: '确定',
            type: 'primary',
            onClick: function () {
              _this.updatepayEnterprise()
            }
          }]
        })
      },
      updatepayEnterprise () {
        var self = this
        console.log(self.payEnterpriseList)
        let payEnterpriseNos = []
        self.payEnterpriseList.forEach(payEnterpriseNo => {
          if (payEnterpriseNo.enterpriseNo && payEnterpriseNo.enterpriseNo !== '') {
            payEnterpriseNos.push(payEnterpriseNo.enterpriseNo)
          }
        })
        self.$weui.loading('正在更新订单开票抬头')
        var param = {
          payEnterpriseNoList: payEnterpriseNos,
          rootOrderId: self.order.id
        }
        self.gcapi('updateOnlineOrderPayEnterprise', param).then(function (response) {
          self.$weui.loading().hide()
          self.$weui.toast('更新成功！', 2500)
          self.toPayInvoice()
        })
      },
      toPayInvoice () {
        this.$router.replace({name: 'updateInvoiceTitle', params: {order: this.$route.params.order}})
      }
    }
  }

</script>
<style scoped>
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }
  .alert-text {
    color: #FE654D;
  }
  .container {
    overflow-y:scroll;
    overflow-x:hidden;
    position: relative;
    background-color: #FAFAFA;
  }
  .order-content {
    /*border: 1px solid #000000;*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 86px;
    overflow: scroll;
    padding: 10px;
    padding-bottom: 0;
    font-size: 12px;
  }
  .order-container {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100vh;
    position: relative;
    background-color: #FAFAFA;
    padding: 10px;
    padding-bottom: 0;
    font-size: 12px;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
  }
  .order-detail-container {
    overflow-x:hidden;
    overflow-y: scroll;
    height: calc(100vh - 80px);
    position: relative;
    margin-top: 0;
    padding: 0 15px;
    border-radius: 10px;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
  }

  .block-item {
    height: 62px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }

  .full-split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    margin-left: -15px;
    height: 1px;
  }
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .choose-balance-account, .choose-pay-method {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .verity-info {
    text-align: left;
    font-size: 14px;
    color: #979797;
    font-weight: normal;
    width: 60%;
    outline: none;
    border: none;
    padding: 0;
  }
  .verify-account {
    background-color: #FAFAFA;
    padding: 10px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    font-size: 14px;
  }
  .remind-info {
    line-height: 20px;
    padding: 0 10px;
  }

  .info4 {
    width: 32px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 16px;
    font-family: PingFangSC-Regular;
    line-height: 22px;
    text-align: left;
    align-self: flex-start;
    margin: 15px 0 0 20px;
    margin-bottom: 10px;
  }
  .main3 {
    border-radius: 5px;
    width: 100%;
    margin-right: 15px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    border-radius: 5px;
    background-color: rgba(250, 250, 250, 1);
    -ms-flex-item-align: start;
    align-self: flex-start;
    margin-top: 10px;
    /*background-color: rgba(249, 249, 249, 249);*/
  }
  .main3:active{
    background: #EFEEF3;
  }
  .main4 {
    border-radius: 5px;
    background-color: rgba(239, 238, 243, 1);
    justify-content: center;
    align-items: flex-start;
    padding-left: 1px;
    width: 222px;
    font-size: 14px;
    height: 40px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
  }
  .invoice-label {
    width: 34px;
    position: absolute;
    top: 0;
    left: 0;
    height: 34px;
    z-index: 5;
  }
  .address-label {
    width: 34px;
    position: absolute;
    top: 0;
    left: 0;
    height: 34px;
    z-index: 5;
  }
  .order-content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 20px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
  }
  .copy-orderno {
    width:42px;
    height:23px;
    line-height: 21px;
    text-align: center;
    border-radius:44px;
    border:1px solid rgba(151,151,151,1);
  }
  .update-address {
    width: 42px;
    height: 23px;
    line-height: 21px;
    text-align: center;
    border-radius: 44px;
    border: 1px solid #5878FA;
  }

  .update-address-color {
    font-size: 12px;
    color: #5878FA;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 75%;
  }
  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
  }

  .footer-content {
    display: flex;
    align-items: center;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 100%;
    height: 58px;
    padding: 0px 10px;
  }

  .del-btn {
    display: flex;
    justify-content: center;
    border-radius: 22px;
    background-color: #fff;
    border: 1px solid #5878fa;
    width: 172px;
    height: 44px;
    margin-right: 11px;
    margin-left: 10px;
  }

  .sub-btn {
    display: flex;
    justify-content: center;
    border-radius: 22px;
    background-color: #5878fa;
    width: 172px;
    height: 44px;
    margin-right: 10px;
  }

  .tag {
    color: #ffffff;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    position: relative;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6rem .45rem;
  }

  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  label.label-checkbox input[type=checkbox]:checked+.item-media i.icon-form-checkbox, label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// InvoiceTitleModify.vue?1f71b34d